import * as DASHBOARDUSERS from './dashboardUsers.constants';
import { DashboardUsers } from '../../models';

/** LOAD */
export function loadDashboardUsers() {
    return { type: DASHBOARDUSERS.DASHBOARD_USERS_LOAD };
}

export function loadDashboardUsersSuccess(data: DashboardUsers) {
    return { type: DASHBOARDUSERS.DASHBOARD_USERS_LOAD_SUCCESS, payload: data };
}

export function loadDashboardUsersError(error: any) {
    return { type: DASHBOARDUSERS.DASHBOARD_USERS_LOAD_ERROR, payload: error };
}